import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector:
    '.m-grid__item.m-grid__item--fluid.m-grid.m-grid--ver-desktop.m-grid--desktop.m-body',
    templateUrl: './subheader--type-search.component.html',
    encapsulation: ViewEncapsulation.None
})
export class SubheaderTypeSearchComponent implements OnInit {
    constructor() { }
    ngOnInit() { }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/subheader--type-search/subheader--type-search.component.ts